module.exports = __webpack_public_path__ + "static/media/Latifa.5f7c8e4b.jpg";